import { render, staticRenderFns } from "./ConsumerScoreLog.vue?vue&type=template&id=6b1f3eca"
import script from "./ConsumerScoreLog.vue?vue&type=script&lang=js"
export * from "./ConsumerScoreLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports